import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import RequiredLabel from "./RequiredLabel";

/**
 * 複数行入力フィールドコンポーネント
 *
 * @param {string}   label        フィールドの表示ラベル
 * @param {number}   rows         表示する行数
 * @param {string}   name         フィールド名（フォーム連携用）
 * @param {string}   value        入力中の文字列
 * @param {function} onChange     値変更ハンドラ
 * @param {string}   [placeholder=""] プレースホルダー
 * @param {boolean}  [isRequired=false] 必須表示フラグ
 * @param {number}   [maxLength]  最大文字数（指定がある場合、カウンターを表示）
 * @param {boolean}  [error=false] エラーフラグ（true の場合はエラースタイル）
 * @param {string}   [helperText] 補足テキスト（エラーや説明を表示）
 */

const FormMultilineField = ({
  label,
  rows,
  name,
  value,
  onChange,
  placeholder = "",
  isRequired = false,
  maxLength,
  error = false,
  helperText,
}) => {
  const charCount = value ? value.length : 0;

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography>{label}</Typography>
        <RequiredLabel show={isRequired} />
      </Box>
      <TextField
        fullWidth
        multiline
        rows={rows}
        name={name}
        value={value}
        onChange={onChange}
        error={error}
        placeholder={placeholder}
        inputProps={maxLength ? { maxLength } : {}}
        helperText={helperText || (maxLength ? `${charCount}文字` : undefined)}
        sx={{ "& textarea:focus": { boxShadow: "none" } }}
        FormHelperTextProps={{
          sx: { textAlign: "right", marginRight: "0" },
        }}
      />
    </Box>
  );
};

export default FormMultilineField;
